import React, { useState, useEffect, useInsertionEffect } from "react";
import Nav from "react-bootstrap/Nav";
import dayjs from "dayjs";
import EventServices from "../../services/EventServices";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { IMemberEvent } from "../../store/eventApiSlice";
import { display } from "html2canvas/dist/types/css/property-descriptors/display";
import { direction } from "html2canvas/dist/types/css/property-descriptors/direction";
import { Link, useNavigate } from "react-router-dom";
import ButtonWithIcon from "../StyledComp/ButtonWithIcon";
import OrderIcon from "../../Images/MenuIconComp/OrderIcon";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import OrderServices from "../../services/OrderServices";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import ReactModal from "react-modal";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import { Controller, useForm } from "react-hook-form";
import { IPaymentInfo } from "../../store/memberInterfaceStruct";
import {
  initalOrderItem,
  IOrderItem,
  storeUpdateOrder,
} from "../../store/orderApiSlice";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import TextField from "@mui/material/TextField";
import MemberServices from "../../services/MemberServices";
import InvoiceServices from "../../services/InvoiceServices";
import { IMemberOrder } from "../../store/orderApiSlice";
import CreateOrder from "../../components/Order/CreateOrder";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import CreateAdvanceOrder from "../Order/CreateAdvanceOrder";

interface MDEventDetailsProps {
  isCreateOrderButtonClicked: boolean;
  setIsCreateOrderButtonClicked: React.Dispatch<React.SetStateAction<boolean>>;
}

const MDEventDetails: React.FC<MDEventDetailsProps> = ({
  isCreateOrderButtonClicked,
  setIsCreateOrderButtonClicked,
}) => {
  const member = useAppSelector((state) => state.currentMember);
  const [filterBy, setFilterBy] = useState<string>("Membership");
  const [sortBy, setSortBy] = useState<string>("EffectiveFiscalYearDateStart");
  const [sortType, setSortType] = useState<string>("DESC");
  const currentMemberId = useSelector(
    (state: RootState) => state.memberApiSlice.FindMemberData.MemberId
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const currentYear = dayjs().month() < 6 ? dayjs().year() - 1 : dayjs().year();
  const currentFiscalYearStart = dayjs(`${currentYear}-07-01`).startOf("day");

  const [orderItem, setOrderItem] = useState<IOrderItem>({
    ...initalOrderItem,
  });
  // const formPaymentInfo = useForm<IPaymentInfo>();
  // const {
  //   register: registerPI,
  //   control: controlPI,
  //   handleSubmit: handleSubmitPI,
  //   formState: formStatePI,
  //   setValue: setValuePI,
  //   clearErrors: clearErrorsPI,
  // } = formPaymentInfo;

  const [memberEventList, setmemberEventList] = useState<IMemberEvent[]>([]);
  const [currentYearActiveOrderId, setCurrentYearActiveOrderId] = useState<
    number[]
  >([]);
  const [proratedDue, setProratedDue] = useState<number | null>(null);
  const [hasCurrentYearOrder, setHasCurrentYearOrder] =
    useState<boolean>(false);
  // const [currentYearOrder, setCurrentYearOrder] = useState<IMemberEvent>();

  const orderInfo = useAppSelector((store) => store.orderapislice);

  const [createOrderModalOpen, setCreateOrderModalOpen] = useState(false);
  const [selectMembershipModalOpen, setSelectMembershipModalOpen] =
    useState(false);

  const [isPaymentFlow, setIsPaymentFlow] = useState<boolean>(false);
  const [isAddSectionFlow, setIsAddSectionFlow] = useState<boolean>(false);
  const [isAdvanceOrder, setIsAdvanceOrder] = useState<boolean>(false);

  const [viewInvoiceModalOpen, setViewInvoiceModalOpen] = useState(false);
  const [InvoiceURL, setInvoiceURL] = useState<string>("");

  const getCurrentFiscalYearStart = () => {
    const today = new Date();
    const currentYear = today.getFullYear();

    // Determine if today's date is before or after May 31
    if (
      today.getMonth() > 4 ||
      (today.getMonth() === 4 && today.getDate() > 31)
    ) {
      // After May 31: Fiscal year starts this year
      return new Date(`${currentYear}-05-31T23:59:59Z`);
    } else {
      // Before May 31: Fiscal year started last year
      return new Date(`${currentYear - 1}-05-31T23:59:59Z`);
    }
  };

  useEffect(() => {
    console.log("isCreateOrderButtonClicked:", isCreateOrderButtonClicked);
    setSelectMembershipModalOpen(isCreateOrderButtonClicked);
  }, [isCreateOrderButtonClicked]);

  useEffect(() => {
    console.log("MDEventDetails CALLED for:", currentMemberId);
    const getEventLists = async () => {
      try {
        const response = await EventServices.getMemberEventList(
          { eventType: filterBy, sortBy: sortBy, sortType: sortType },
          currentMemberId
        );
        console.log("MemberEventOrder:", response.data.data);
        setmemberEventList(response.data.data || []);

        // getting active order list for currenFY. during payment flow
        // I will create new order and cancel this order.
        const currentFYStart = getCurrentFiscalYearStart();
        console.log("currentFYStart:", currentFYStart);
        const CurrentYearActiveOrderIds_temp = response.data.data
          .filter(
            (event: any) =>
              event.OrderStatus === 1 &&
              new Date(event.EffectiveFiscalYearDateStart) > currentFYStart
          )
          .map((event: any) => event);
        setCurrentYearActiveOrderId(CurrentYearActiveOrderIds_temp[0].OrderId);
        setProratedDue(CurrentYearActiveOrderIds_temp[0].ProratedDues || null);
        console.log("CurrentYearActiveOrders:", CurrentYearActiveOrderIds_temp);
      } catch (error) {
        console.error("Error fetching event list:", error);
      }
    };

    getEventLists();
  }, [filterBy, currentMemberId, sortBy, sortType]);

  useEffect(() => {
    setHasCurrentYearOrder(
      memberEventList.some((event: any) => {
        console.log(
          "event.EffectiveFiscalYearDateStart:",
          dayjs(event.EffectiveFiscalYearDateStart).format("YYYY") +
            " " +
            dayjs(currentFiscalYearStart).format("YYYY")
        );
        console.log(
          dayjs(event.EffectiveFiscalYearDateStart)
            .format("YYYY")
            .toString() ===
            dayjs(currentFiscalYearStart).format("YYYY").toString()
        );
        return (
          dayjs(event.EffectiveFiscalYearDateStart).format("YYYY") ===
            dayjs(currentFiscalYearStart).format("YYYY") ||
          dayjs(event.EffectiveFiscalYearDateStart).format("YYYY") >
            dayjs(currentFiscalYearStart).format("YYYY")
        );
      })
    );
    // setCurrentYearOrder(
    //   memberEventList.find(
    //     (event) =>
    //       dayjs(event.EffectiveFiscalYearDateStart).format("YYYY") ===
    //       dayjs(currentFiscalYearStart).format("YYYY")
    //   )
    // );
  }, [memberEventList]);

  const handleFilterBy = (data: string) => {
    if (filterBy !== data) {
      setmemberEventList([]);
      setFilterBy(data);
    }
  };

  const handleSort = (newSortField: string) => {
    console.log("Handle sort called");
    setSortType(
      newSortField === sortBy ? (sortType === "DESC" ? "ASC" : "DESC") : "ASC"
    );
    setSortBy(newSortField);
  };

  const renderSortIcon = (field: string) => {
    if (field === sortBy) {
      return sortType === "DESC" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="27"
          height="30"
        >
          <path fill="#f6ff00" d="M4 13h16l-8 8z" />
          <path fill="#d5d5d5" d="M12 3l8 8H4z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="27"
          height="30"
          // fill="#f6ff00"
        >
          <path fill="#d5d5d5" d="M4 13h16l-8 8z" />
          <path fill="#f6ff00" d="M12 3l8 8H4z" />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
          <path d="M4 13h16l-8 8z" />
        </svg>
      );
    }
  };

  const updatePaymentInfo = (e: any, date?: Date | null) => {
    switch (e.target.name) {
      case "PaymentMethod":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PaymentMethod: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "PaymentMethod",
            value: e.target.value,
          })
        );
        break;

      case "DatePaid":
        // const formattedDate = date ? dayjs(date) : null;
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   DatePaid: formattedDate,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "DatePaid",
            value: e.target.value,
          })
        );

        break;

      case "CheckNumber":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   CheckNo: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: e.target.value,
          })
        );
        break;

      case "AmountPaid":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AmountPaid: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "AmountPaid",
            value: Number(e.target.value),
          })
        );
        break;

      case "LateFee":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   LateFee: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "LateFee",
            value: e.target.value,
          })
        );
        break;

      case "AuthCode":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   AuthCode: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: e.target.value,
          })
        );
        break;

      case "PIcomments":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   PIComments: e.target.value,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "Comments",
            value: e.target.value,
          })
        );
        break;

      case "NoInvoiceFlag":
        // setPaymentInfo((prevValues) => ({
        //   ...prevValues,
        //   NoInvoiceFlag: false,
        // }));
        dispatch(
          storeUpdateOrder({
            key: "NoInvoice",
            value: e.target.checked,
          })
        );
        break;

      default:
        console.log("default");
        break;
    }
  };

  // const onSubmitPaymentInfo = async (e: any) => {
  //   // e.preventDefault();
  //   console.log("onSUBMIT:", orderInfo);

  //   const apiBody: any = orderInfo;
  //   const response = await OrderServices.createPayment(apiBody);

  //   if (response.data.data != null) {
  //     alert("Payment Posted successfully");
  //     console.log("Payment response:", response);
  //     setPIModalOpen(false);
  //     dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  //     navigate("/member/findmember", { replace: true });
  //     //   // dispatch(resetOrderParameters());  I am doing this in useEffect
  //     //   // navigate("/order", { replace: true });
  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.viewOrder));
  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));

  //     //   dispatch(
  //     //     storeUpdateOrder({
  //     //       key: "TransactionAmount",
  //     //       value: 0,
  //     //     })
  //     //   );

  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
  //     //   navigate("/member/findmember", { replace: false });
  //     //   // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
  //     //   //  dispatch(screenChange("Events"));
  //   } else {
  //     alert(response.data.errors);
  //     console.log("error");
  //   }
  // };

  // const handleCancel = () => {
  //   setPIModalOpen(false);
  //   setIsPaymentFlow(false);
  // };

  const handleCreateOrderCancel = () => {
    setCreateOrderModalOpen(false);
    console.log("handle Cancel CALLED");
  };

  const handleSelectMembership = () => {
    setSelectMembershipModalOpen(false);
    setIsPaymentFlow(false);
    setIsCreateOrderButtonClicked(false);
  };

  const showInvoiceWindow = (event: any) => {
    console.log(event);
    console.log(event.InvoiceUrl);
    setInvoiceURL(event.InvoiceUrl);
    setViewInvoiceModalOpen(true);
  };

  const handleSendInvoice = async () => {
    if (
      member &&
      member.PrimaryAddress &&
      member.PrimaryAddress.Email === null &&
      member.PublishedAddress &&
      member.PublishedAddress.Email === null
    ) {
      alert("Email ID missing");
      return;
    }
    let body = {
      InvoiceLink: InvoiceURL,
      FirstName: member && member.FirstName,
      LastName: member && member.LastName,
      Esquired: member && member.Esquire,
      MemberEmail:
        member && member.PrimaryAddress && member && member.PrimaryAddress.Email
          ? member && member.PrimaryAddress.Email
          : member &&
            member.PublishedAddress &&
            member &&
            member.PublishedAddress.Email,
    };

    const response = await MemberServices.sendInvoiceEmailToMember(body);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      console.log("Success");
      console.log("response1...", response.data.data);
      alert("Mail Sent Successfully");
      // navigate("/member", { replace: false });
    } else {
      console.log("error", response);
    }
    setViewInvoiceModalOpen(false);
  };

  const onSubmitOrderInfo = async (e: any) => {
    // e.preventDefault();
    console.log("onSUBMIT:", orderInfo);

    const apiBody: any = orderInfo;
    try {
      const response = await OrderServices.createOrder(apiBody);
      console.log("ORDER response", response);
      if (response != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        setCreateOrderModalOpen(false);
        console.log("ORDER response", response);
        const apiBody1: any = {
          orderId: response.data.data.insertId,
          memberId: orderInfo.MemberId,
          paymentStaus: 1, //invoice created
        };
        if (
          member.MemberTags?.some((tag) => tag.Id === 44) ||
          member.MemberCodeId === 21 ||
          member.MemberCodeId === 22
        ) {
          navigate("/member/findmember", { replace: true });
          return;
        } else {
          const response1 =
            await InvoiceServices.createMembershipOrderInvoiceSync(apiBody1);
          console.log("INVOICE response", response1.data.data);
          console.log("INVOICE URL", response1.data.data[0].InvoiceUrl);
          if (response1.data.data && response1.data.data.length > 0) {
            if (response.data.hasErrors) {
              setShowAlertModal(true);
              setAlertTitle("Database Error");
              setAlertBody(response.data.errors[0].sqlMessage);
              return;
            }
            setInvoiceURL(response1.data.data[0].InvoiceUrl);
            setViewInvoiceModalOpen(true);
            console.log(
              "INVOICE response",
              response1.data.data.Invoices[0].InvoiceUrl
            );
          }
        }
      } else {
        // alert(response.data.errors);
        console.log("error");
      }
    } catch (error) {
      console.error("ORDER: Error creating order:", error);
    }
  };

  const color1 = "#2d6289";
  const color2 = "#008800";
  const colorError = "#FF0000";
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  return (
    <div className="section-box">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">History</h1>
        <Nav
          className="custom-tabs d-flex justify-content-start text-center align-item-center"
          variant="tabs"
          style={{ marginBottom: "0.5rem" }}
          activeKey={filterBy}
        >
          <div className="heading_small" style={{ marginRight: "0.5rem" }}>
            Filter By:
          </div>
          <Nav.Item className="fs-5">
            <Nav.Link
              className="nav-small-label nav-tag-style"
              eventKey="Membership"
              onClick={() => handleFilterBy("Membership")}
            >
              Dues
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="fs-5">
            <Nav.Link
              className="nav-small-label nav-tag-style"
              eventKey="Function"
              onClick={() => handleFilterBy("Function")}
            >
              Function
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="fs-5">
            <Nav.Link
              className="nav-small-label nav-tag-style"
              eventKey="Seminar"
              onClick={() => handleFilterBy("Seminar")}
            >
              Seminar
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="fs-5">
            <Nav.Link
              className="nav-small-label nav-tag-style"
              eventKey="Video"
              onClick={() => handleFilterBy("Video")}
            >
              Video
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
      {filterBy === "Membership" ? (
        <>
          {/* id member has no order for current FY, we will show this row 
                on top of list from past years*/}
          {/* {memberEventList.map((event: any) =>
            event.DueAmount > 0 ? (
              <div className="secondary-button1">
                <Link to="/order/create-order" className="menubar-link">
                  <ButtonWithIcon
                    icon={<OrderIcon height={25} width={25} />}
                    buttontext="Create Order"
                    onClick={() => setSelectMembershipModalOpen(true)}
                    // onClick={() => setPIModalOpen(true)}
                  />
                </Link>
              </div>
            ) : (
              <></>
            )
          )} */}
          <div className="memberEventlist-table">
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
                borderLeft: "1px solid #ddd",
                borderRight: "1px solid #ddd",
              }}
            >
              <thead>
                <tr key={"1"}>
                  <th
                    className="eventid-table"
                    onClick={() => handleSort("EffectiveFiscalYearDateStart")}
                  >
                    Year{renderSortIcon("EffectiveFiscalYearDateStart")}
                  </th>
                  <th className="eventid-table">Member Code</th>
                  {/* <th className="eventname-table" style={{ width: "30%" }}>
                    Description
                  </th> */}
                  <th className="eventdate-table">Sections</th>
                  <th className="eventdate-table">Bill Amount</th>
                  <th className="eventdate-table">Amount Paid</th>
                  <th className="eventdate-table">Due</th>
                  <th className="eventdate-table"></th>{" "}
                  {/* place holder for button */}
                </tr>
              </thead>
              <tbody>
                {hasCurrentYearOrder !== true ? (
                  <tr key={"1"}>
                    <td>{dayjs(currentFiscalYearStart).format("YYYY")}</td>
                    <td> -- </td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>--</td>
                    <td>
                      <div className="order-details-container">
                        <div className="secondary-button1">
                          {/* <Link to="/order/create-order" className="menubar-link"> */}
                          <ButtonWithIcon
                            icon={<OrderIcon height={25} width={25} />}
                            buttontext="Create Order"
                            onClick={() => {
                              setSelectMembershipModalOpen(true);
                            }}
                            // onClick={() => setPIModalOpen(true)}
                          />
                          {/* </Link> */}
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}

                {/* records from past year */}
                {memberEventList.map((event: any, index: number) => (
                  <tr key={event.EventId}>
                    <td>
                      {event.EffectiveFiscalYearDateStart != null
                        ? dayjs(event.EffectiveFiscalYearDateStart).format(
                            "YYYY"
                          )
                        : "--"}
                    </td>
                    <td>{event.MemberCode}</td>
                    {/* <td>{event.Description}</td> */}
                    <td>
                      {event.SectionNames
                        ? event.SectionNames.split(", ").map(
                            (sectionName: any) => <div>{sectionName}</div>
                          )
                        : "-"}
                    </td>
                    <td>{event.TotalAmount}</td>
                    <td>{event.AmountPaid}</td>
                    <td>{event.DueAmount}</td>
                    <td>
                      {event.OrderStatus === 1 && (index === 0 &&
                      (hasCurrentYearOrder === true &&
                      member.IsCurrentYearDuePaid !== 1) || (dayjs(event.EffectiveFiscalYearDateStart).format("YYYY") >
                      dayjs(currentFiscalYearStart).format("YYYY"))) ? (
                        // && member.IsCurrentYearDuePaid !== 1
                        // &&
                        // hasCurrentYearOrder &&
                        // event.OrderStatus !== 1
                        <div className="order-details-container">
                          <div className="secondary-button1">
                            {/* <Link
                              to="/order/create-order"
                              className="menubar-link"
                            > */}
                            <ButtonWithIcon
                              icon={<OrderIcon height={25} width={25} />}
                              buttontext="Create Order"
                              onClick={() => {
                                setSelectMembershipModalOpen(true);
                                setIsAdvanceOrder(
                                  dayjs(
                                    event.EffectiveFiscalYearDateStart
                                  ).format("YYYY") >
                                    dayjs(currentFiscalYearStart).format("YYYY")
                                );
                              }}
                              // onClick={() => setPIModalOpen(true)}
                            />
                            {/* </Link> */}
                          </div>
                        </div>
                      ) : (
                        // : event.OrderStatus === 1 &&
                        //   dayjs(event.EffectiveFiscalYearDateStart).format(
                        //     "YYYY"
                        //   ) === dayjs(currentFiscalYearStart).format("YYYY") ? (
                        //   // && event.DueAmount > 0
                        //   <div className="order-details-container">
                        //     <div className="secondary-button1 ">
                        //       {/* <Link
                        //         to="/order/create-order"
                        //         className="menubar-link"
                        //       > */}
                        //       <ButtonWithIcon
                        //         icon={<OrderIcon height={25} width={25} />}
                        //         buttontext="Create Order"
                        //         onClick={() => setCreateOrderModalOpen(true)}
                        //         // onClick={() => setPIModalOpen(true)}
                        //       />
                        //       {/* </Link> */}
                        //     </div>
                        //   </div>
                        // )
                        <></>
                      )}

                      {event.OrderStatus === 1 &&
                      (dayjs(event.EffectiveFiscalYearDateStart).format(
                        "YYYY"
                      ) === dayjs(currentFiscalYearStart).format("YYYY") || dayjs(event.EffectiveFiscalYearDateStart).format(
                        "YYYY"
                      ) > dayjs(currentFiscalYearStart).format("YYYY")) ? (
                        <div className="order-details-container">
                          <PageLink
                            onClick={() => {
                              // setPIModalOpen(true);
                              setSelectMembershipModalOpen(true);
                              setIsPaymentFlow(true);
                              setIsAdvanceOrder(dayjs(event.EffectiveFiscalYearDateStart).format(
                                "YYYY"
                              ) > dayjs(currentFiscalYearStart).format("YYYY"));
                            }}
                          >
                            Make Payment
                          </PageLink>
                        </div>
                      ) : (
                        <></>
                      )}
                      {/* index === 0 && */ event.OrderStatus === 2 &&
                      (dayjs(event.EffectiveFiscalYearDateStart).format(
                        "YYYY"
                      ) === dayjs(currentFiscalYearStart).format("YYYY") ||
                        dayjs(event.EffectiveFiscalYearDateStart).format(
                          "YYYY"
                        ) > dayjs(currentFiscalYearStart).format("YYYY")) ? (
                        <div className="order-details-container">
                          <PageLink
                            onClick={() => {
                              // setPIModalOpen(true);
                              setSelectMembershipModalOpen(true);
                              setIsPaymentFlow(true);
                              setIsAdvanceOrder(
                                dayjs(
                                  event.EffectiveFiscalYearDateStart
                                ).format("YYYY") >
                                  dayjs(currentFiscalYearStart).format("YYYY")
                              );
                            }}
                          >
                            Make Payment
                          </PageLink>
                        </div>
                      ) : (
                        <></>
                      )}
                      {
                        /* index === 0 && */ event.OrderStatus === 2 &&
                        dayjs(event.EffectiveFiscalYearDateStart).format(
                          "YYYY"
                        ) ===
                          dayjs(currentFiscalYearStart).format(
                            "YYYY"
                          ) /* || dayjs(event.EffectiveFiscalYearDateStart).format(
                        "YYYY"
                      ) > dayjs(currentFiscalYearStart).format("YYYY") */ ? (
                          <div className="order-details-container">
                            <PageLink
                              onClick={() => {
                                // setPIModalOpen(true);
                                setSelectMembershipModalOpen(true);
                                setIsPaymentFlow(true);
                                setIsAddSectionFlow(true);
                                setIsAdvanceOrder(
                                  dayjs(
                                    event.EffectiveFiscalYearDateStart
                                  ).format("YYYY") >
                                    dayjs(currentFiscalYearStart).format("YYYY")
                                );
                              }}
                            >
                              Add Section
                            </PageLink>
                          </div>
                        ) : (
                          <></>
                        )
                      }
                      {event.InvoiceUrl ? (
                        <div className="order-details-container">
                          <PageLink
                            onClick={() => {
                              showInvoiceWindow(event);
                            }}
                          >
                            View Invoice
                          </PageLink>
                        </div>
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : filterBy === "Function" ? (
        <div className="memberEventlist-table">
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              borderLeft: "1px solid #ddd",
              borderRight: "1px solid #ddd",
            }}
          >
            <thead>
              <tr>
                <th className="eventid-table">Date Paid</th>
                <th className="eventid-table">Event ID</th>
                <th className="eventname-table" style={{ width: "30%" }}>
                  Event Name
                </th>
                <th className="eventdate-table">Start Date</th>
                <th className="eventdate-table">End Date</th>
              </tr>
            </thead>
            <tbody>
              {memberEventList.map((event: any) => (
                <tr key={event.EventId}>
                  <td>
                    {event.DatePaid != null
                      ? dayjs(event.DatePaid).format("MM-DD-YYYY")
                      : "--"}
                  </td>
                  <td>{event.UniqueEventId}</td>
                  <td>{event.EventName}</td>
                  <td>
                    {event.StartDateTime != null
                      ? dayjs(event.StartDateTime).format("MM-DD-YYYY HH:mm A")
                      : "--"}
                  </td>
                  <td>
                    {event.EndDateTime != null
                      ? dayjs(event.EndDateTime).format("MM-DD-YYYY HH:mm A")
                      : "--"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : filterBy === "Seminar" ? (
        <div className="memberEventlist-table">
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              borderLeft: "1px solid #ddd",
              borderRight: "1px solid #ddd",
            }}
          >
            <thead>
              <tr>
                <th className="eventid-table">Date Paid</th>
                <th className="eventid-table">Event ID</th>
                <th className="eventname-table" style={{ width: "30%" }}>
                  Event Name
                </th>
                <th className="eventdate-table">DE Credits</th>
                <th className="eventdate-table">DE Ethics</th>
                <th className="eventdate-table">PA Credits</th>
                <th className="eventdate-table">PA Ethics</th>
                <th className="eventdate-table">NJ Credits</th>
                <th className="eventdate-table">NJ Ethics</th>
              </tr>
            </thead>
            <tbody>
              {memberEventList.map((event: any) => (
                <tr key={event.EventId}>
                  <td>
                    {event.DatePaid != null
                      ? dayjs(event.DatePaid).format("MM-DD-YYYY")
                      : "--"}
                  </td>
                  <td>{event.UniqueEventId}</td>
                  <td>{event.EventName}</td>
                  <td>
                    {event.EarnedDECredits != null &&
                    event.EarnedDECredits !== 0
                      ? event.EarnedDECredits
                      : "-"}
                  </td>
                  <td>
                    {event.EarnedDEEEthics != null &&
                    event.EarnedDEEEthics !== 0
                      ? event.EarnedDEEEthics
                      : "-"}
                  </td>
                  <td>
                    {event.EarnedPACredits != null &&
                    event.EarnedPACredits !== 0
                      ? event.EarnedPACredits
                      : "-"}
                  </td>
                  <td>
                    {event.EarnedPAEEthics != null &&
                    event.EarnedPAEEthics !== 0
                      ? event.EarnedPAEEthics
                      : "-"}
                  </td>
                  <td>
                    {event.EarnedNJCredits != null &&
                    event.EarnedNJCredits !== 0
                      ? event.EarnedNJCredits
                      : "-"}
                  </td>
                  <td>
                    {event.EarnedNJEthics != null && event.EarnedNJEthics !== 0
                      ? event.EarnedNJEthics
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : filterBy === "Video" ? (
        <div className="memberEventlist-table">
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              borderLeft: "1px solid #ddd",
              borderRight: "1px solid #ddd",
            }}
          >
            <thead>
              <tr>
                <th className="eventid-table">Date Paid</th>
                <th className="eventid-table">Event ID</th>
                <th className="eventname-table" style={{ width: "30%" }}>
                  Event Name
                </th>
                <th className="eventdate-table">Completed Date</th>
                <th className="eventdate-table">DE Credits</th>
                <th className="eventdate-table">DE EnchEthics</th>
                <th className="eventdate-table">PA Credits</th>
                <th className="eventdate-table">PA Ethics</th>
                <th className="eventdate-table">NJ Credits</th>
                <th className="eventdate-table">NJ Ethics</th>
              </tr>
            </thead>
            <tbody>
              {memberEventList.map((event: any) => (
                <tr key={event.EventId}>
                  <td>
                    {event.DatePaid != null
                      ? dayjs(event.DatePaid).format("MM-DD-YYYY")
                      : "--"}
                  </td>
                  <td>{event.UniqueEventId}</td>
                  <td>{event.EventName}</td>
                  <td>
                    {event.DateCompleted != null
                      ? dayjs(event.DateCompleted).format("MM-DD-YYYY")
                      : "--"}
                  </td>
                  <td>{event.DECredits !== 0 ? event.DECredits : "-"}</td>
                  <td>{event.DEEnchEthics !== 0 ? event.DEEnchEthics : "-"}</td>
                  <td>{event.PACredits !== 0 ? event.PACredits : "-"}</td>
                  <td>{event.PAEthics !== 0 ? event.PAEthics : "-"}</td>
                  <td>{event.NJCredits !== 0 ? event.NJCredits : "-"}</td>
                  <td>{event.NJEthics !== 0 ? event.NJEthics : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}

      {/* moved to CreateOrder.tsx */}
      {/* <ReactModal
        isOpen={PIModalOpen}
        onRequestClose={() => {
          setPIModalOpen(false);
          isPaymentFlow ? setIsPaymentFlow(false) : null;
          isOrderFlow ? setIsOrderFlow(false) : null;
        }}
        className="editinfo-modal-medium"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Update Pay Information</h1>
          <PageLink onClick={handleCancel}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmitPI(onSubmitPaymentInfo)}
          noValidate
        >
          <div className="input-field-div-wrapper">
            <select
              className="dropdown-control-large-insidetextfield"
              name="PaymentMethod"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            >
              <option value={""}> Select Payment Type </option>
              <option value="American Express">American Express</option>
              <option value="Authorize.net">Authorize.net</option>
              <option value="Check">Check</option>
              <option value="Discover">Discover</option>
              <option value="MasterCard">MasterCard</option>
              <option value="Visa">Visa</option>
              <option value="Website">Website</option>
            </select>
          </div>

          <div style={{ width: "28%", marginBottom: "1.8rem" }}>
            <Controller
              control={controlPI}
              name="DatePaid"
              // rules={{ required: "* required field" }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Date Paid"
                      value={value ? dayjs(value).toDate() : null}
                      onChange={(date: Date | null) => {
                        const formattedDate = date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : null;
                        const syntheticEvent = {
                          target: {
                            name: "DatePaid",
                            value: date
                              ? dayjs(date).format("YYYY-MM-DD")
                              : null,
                          },
                        };
                        updatePaymentInfo(syntheticEvent, date);
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="CheckNumber"
              name="CheckNumber"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="CheckNumber">
              Check Number
            </label>
          </div>
          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AmountPaid"
              name="AmountPaid"
              pattern="0-9"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              value={orderInfo.AmountPaid}
              // disabled={true}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AmountPaid">
              Amount Paid
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="LateFee"
              name="LateFee"
              placeholder=""
              pattern="[0-9]*"
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="LateFee">
              Late Fee
            </label>
          </div>

          <div className="input-field-div-wrapper">
            <input
              className="input-field-div-small"
              id="AuthCode"
              name="AuthCode"
              placeholder=""
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
              disabled={false}
              autoComplete="off"
            />
            <label className="form-label" htmlFor="AuthCode">
              Auth Code
            </label>
          </div>

          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <TextField
              className="textarea"
              id="PIcomments"
              name="PIcomments"
              placeholder="Comments"
              multiline
              rows={3}
              onChange={(e) => {
                updatePaymentInfo(e);
              }}
            />
          </div>

          <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </ReactModal> */}

      <ReactModal
        isOpen={viewInvoiceModalOpen}
        onRequestClose={() => setViewInvoiceModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">View INVOICE</h1>
          <div className="d-flex" style={{ width: "30%" }}>
            <div className="secondary-button">
              <Button
                type="submit"
                onClick={() => setViewInvoiceModalOpen(false)}
              >
                Close
              </Button>
            </div>
            <div className="secondary-button">
              <Button type="submit" onClick={handleSendInvoice}>
                Email Invoice
              </Button>
            </div>
          </div>
          <div className="pdf-container">
            <iframe
              title={`Invoice - ${member?.FirstName ?? ""} ${
                member?.LastName ?? ""
              } - ${Date.now()}`}
              src={InvoiceURL}
              allow="autoplay"
              loading="lazy"
            />
          </div>
        </div>
      </ReactModal>

      <ReactModal
        isOpen={selectMembershipModalOpen}
        onRequestClose={() => {
          setSelectMembershipModalOpen(false);
          setIsCreateOrderButtonClicked(false);
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">
            Select Membership and Sections (
            {member?.FirstName + " " + member?.LastName})
            {/* {isPaymentFlow ? "-Paymentflow" : "-OrderFlow"} */}
          </h1>
          <div className="secondary-button">
            <Button type="submit" onClick={handleSelectMembership}>
              Close
            </Button>
            {/* </div> */}
          </div>
        </div>
        {isAdvanceOrder ? (
          <CreateAdvanceOrder
            isAddSectionFlow={isAddSectionFlow}
            isPaymentFlow={isPaymentFlow}
            currentYearActiveOrderId={currentYearActiveOrderId}
            proratedDue={proratedDue || null}
          />
        ) : (
          <CreateOrder
            isAddSectionFlow={isAddSectionFlow}
            isPaymentFlow={isPaymentFlow}
            currentYearActiveOrderId={currentYearActiveOrderId}
          />
        )}
        {/* <div className="horizontal-wrapper-centeralign">
          <div className="submit-button-div ">
            <Button
              type="submit"
              // onClick={onSubmit}
            >
              Submit
            </Button>
          </div>
        </div> */}
      </ReactModal>

      {/* <ReactModal
        isOpen={createOrderModalOpen}
        onRequestClose={() => {
          handleCreateOrderCancel();
        }}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Create Order</h1>
          <PageLink onClick={handleCancel}>Cancel</PageLink>

          <span>Development inprogress</span>

           <div className="horizontal-wrapper-centeralign">
            <div className="submit-button-div ">
              <Button
                type="submit"
                // onClick={onSubmit}
              >
                Create Order
              </Button>
            </div>
          </div>
        </form>  
        </div>
      </ReactModal> */}
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MDEventDetails;
